module.exports = __webpack_public_path__ + "img/credits.7a5f0c56.png";